<template>
    <a href="javascript:;" @click.prevent="logout">
        <span v-if="hasIcon" class="icon icon-power-off icon-lg icon-fw"></span>
        {{ $t('auth.logout') }}
    </a>
</template>

<script>
export default {
    props: {
        hasIcon: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            form: new Form({}),
        };
    },

    methods: {
        logout() {
            Globals.post('/logout', this.form)
                .then(() => window.location.href = '/')
                .catch(() => {});
        },
    },
};
</script>
